<template>
  <b-card>
    <h4 class="mb-1">Database backup</h4>
    <p class="text-muted">
      Download a SQL dump of the API database. Restore it with your MySQL client when you need a local copy.
    </p>
    <b-button variant="primary" :disabled="downloading" @click="download">
      {{ downloading ? 'Preparing…' : 'Download database' }}
    </b-button>
  </b-card>
</template>

<script>
import { BButton, BCard } from 'bootstrap-vue'
import { adminPanelApi } from '@/services/adminPanelApi'

export default {
  components: { BButton, BCard },
  data() {
    return { downloading: false }
  },
  methods: {
    async download() {
      this.downloading = true
      try {
        const response = await adminPanelApi.downloadDatabaseBackup()
        const blob = new Blob([response.data], { type: 'application/sql' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        const stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')
        link.href = url
        link.download = `my-poda-${stamp}.sql`
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        this.$swal({
          title: 'Download failed',
          text: error?.response?.data?.message || 'Could not download the database backup.',
          icon: 'error',
        })
      } finally {
        this.downloading = false
      }
    },
  },
}
</script>
